export default __webpack_public_path__ + "static/media/baju1.0bce9b25.webp";